export default __webpack_public_path__ + "static/media/jqilogo.8cf14134.png";